import React from "react";

// core components
import Navbar from "../components/Navbar.js";
// import MobileNavbar from "../components/Navbars/MobileNavbar";
import LandingPageHeader from "components/Headers/LandingPageHeader.js";
import DemoFooter from "../components/Footer.js";
import TextGrid from "../components/TextGrid.js";
import ANZEventOverview from "../components/ANZEventOverview";
import ProgrammeThemesSection from "../components/ProgrammeThemesSection";
import WhyItMattersSection from "../components/WhyItMattersSection";
import FeaturedCaseStudiesSection from "../components/FeaturedCaseStudiesSection";
import AttendAndExperienceSection from "../components/AttendAndExperienceSection";
import TheBiggerVisionSection from "../components/TheBiggerVisionSection";
import Testimonials from "../components/Testimonials";

import AboutPoints from "../components/AboutPoints.js";

import Sponsor from "../components/Sponsor.js";
// import ImageGrid from "../components/ImageGrid.js";
// import PastEventHighlights from "../components/PastEventHighlights";
// import PastEventHighlights1 from "../components/PastEventHighlights1";
// import Workshop from "../components/Workshop.js";
import Speaker from "../components/SpeakerCard";
import SponsorNew from "../components/SponsorNew";

import Attend from "components/Attend.js";
import Editions from "components/Editions.js";

function Home() {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("profile-page");
    return function cleanup() {
      document.body.classList.remove("profile-page");
    };
  });
  const size =
    document.body.clientWidth >= 1024 || document.documentElement.clientWidth >= 1024
      ? true
      : false;
  return (
    <>
      <Navbar />
      <LandingPageHeader />
      {/* <section id="about">
        <TextGrid />
      </section> */}
      <div
        style={{
          backgroundColor: "#fff",
          background: `url(${require("assets/images/photo-1566734904496-9309bb1798ae.jpeg")})`,
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed",
          backgroundPosition: "center",
          backgroundSize: "cover",
          paddingTop: "8rem",
          overflow: "hidden",
        }}
        className="section py-3"
        data-parallax={true}

      >
        <ANZEventOverview />
      </div>

      <div
        style={{
          background: `url(${require(`assets/images/black-smooth-textured-paper.jpg`)})`,
          // backgroudColor: "#020910",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundAttachment: size ? "fixed" : "scroll",
          backgroundSize: "cover",
        }}
        className="section section-with-space"
        data-parallax={true}
      >

        <ProgrammeThemesSection />
        <WhyItMattersSection />
        <FeaturedCaseStudiesSection />
        <Testimonials />
        <AttendAndExperienceSection />
        <TheBiggerVisionSection />
        {/* <section id="attend">
          <Attend />
        </section>
        <AboutPoints /> */}
        <section id="speakers" />
        <Speaker />
        {/* <section id="workshop" />
        <Workshop /> */}
        <section id="partners" />
        <SponsorNew />
        <Editions />
      </div>

      {/* {size ? <PastEventHighlights1 /> : <PastEventHighlights />} */}

      {/* <Sponsor /> */}
      <DemoFooter />
    </>
  );
}

export default Home;
